"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Project/App Name APIs
 * API documentation for the backend services of Project/App Name
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfLogoutDto = instanceOfLogoutDto;
exports.LogoutDtoFromJSON = LogoutDtoFromJSON;
exports.LogoutDtoFromJSONTyped = LogoutDtoFromJSONTyped;
exports.LogoutDtoToJSON = LogoutDtoToJSON;
exports.LogoutDtoToJSONTyped = LogoutDtoToJSONTyped;
/**
 * Check if a given object implements the LogoutDto interface.
 */
function instanceOfLogoutDto(value) {
    return true;
}
function LogoutDtoFromJSON(json) {
    return LogoutDtoFromJSONTyped(json, false);
}
function LogoutDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'deviceId': json['deviceId'] == null ? undefined : json['deviceId'],
    };
}
function LogoutDtoToJSON(json) {
    return LogoutDtoToJSONTyped(json, false);
}
function LogoutDtoToJSONTyped(value, ignoreDiscriminator) {
    if (ignoreDiscriminator === void 0) { ignoreDiscriminator = false; }
    if (value == null) {
        return value;
    }
    return {
        'deviceId': value['deviceId'],
    };
}
